import {HttpResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import saveAs from 'file-saver';
import * as moment from 'moment';
import {Observable, Subscription} from 'rxjs';
import {ICrops} from '@entities/canh-tac/canh-tac.model';
import {IKhuVuc, KhuVucService} from '@entities/khu-vuc';
import {LoaiKhuVucService} from '@entities/loai-khu-vuc/loai-khu-vuc.service';
import {BaoCaoService} from '@entities/bao-cao/bao-cao.service';

import {TranslateService} from '@ngx-translate/core';
import {map} from 'rxjs/operators';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';
@Component({
  selector: 'app-bao-cao',
  templateUrl: './bao-cao.component.html',
  styleUrls: ['./bao-cao.component.scss'],
})
export class BaoCaoComponent implements OnInit {
  typeExport: any;
  entityId: any;
  entityDaTa: Observable<IKhuVuc[]>;
  tbCropTypeId: any;
  tbCropTypeId$: any[];
  minDate: Date;
  maxDate: Date;
  check: boolean;
  startDate: Date;
  endDate: Date;
  month: any;
  year: any;
  isSaving: boolean;
  displayedColumns: string[] = [
    'maLo',
    'khuVuc',
    'nhaMang',
    'tenGiong',
    'dienTich',
    'ngayTrong',
    'trangThai',
    'phuTrach',
    'action',
  ];
  dataSource: any;
  pageSizeOptions: number[];
  ELEMENT_DATA: ICrops[];
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  currentSearch: string;
  routeData: any;
  eventSubscriber: Subscription;
  areaId: any = '';
  noData: boolean;
  constructor(
    private baocaoService: BaoCaoService,
    private entityTypeService: LoaiKhuVucService,
    private canhTacService: CanhTacService,
    private service: KhuVucService,
    private translate: TranslateService,
  ) {
    this.typeExport = null;
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.isSaving = false;
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear);
    this.maxDate = new Date();
    this.check = true;
    this.tbCropTypeId$ = [];
  }

  ngOnInit() {
    this.loadALl();
    this.getEntityData();
  }

  loadALl() {
    // this.baocaoService.reportSeedUseage().subscribe((res) => {
    //
    // });
    // this.baocaoService.reportMonthly(this.month, this.year).subscribe((res) => {
    //
    // });
  }
  save() {
    const param: any = {
      startDate: moment(this.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.endDate).format('YYYY-MM-DD'),
    };
    // if (this.typeExport === 'giamSatVuon') {
    //   this.baocaoService.reportGardenSupervisor(param).subscribe(
    //     (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
    //     () => this.onSaveError(),
    //   );
    // } else if (this.typeExport === 'nhapXuatKho') {
    //   this.baocaoService.reportExportWareHouse(param).subscribe(
    //     (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
    //     () => this.onSaveError(),
    //   );
    // } else if (this.typeExport === 'vatLieuDauVao') {
    //   this.baocaoService.reportImportMaterial(param).subscribe(
    //     (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
    //     () => this.onSaveError(),
    //   );
    // } else if (this.typeExport === 'nhapXuatTonVatTu') {
    //   if (!this.endDate) {
    //     delete param.endDate;
    //   }
    //   this.baocaoService.reportImportExportSuppliesInWarehouse(param).subscribe(
    //     (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
    //     () => this.onSaveError(),
    //   );
    // } else
    if (this.typeExport === 'suDungVatTu') {
      if (this.tbCropTypeId) {
        param.cropId = this.tbCropTypeId;
      }
      param.entityId = this.entityId;
      this.baocaoService.reportSuppliesUsage(param).subscribe(
        (resp: HttpResponse<Blob>) => {
          this.onSaveSuccess(resp);
        },
        () => this.onSaveError(),
      );
    } else if (this.typeExport === 'hoatDongVaCongViec') {
      if (this.tbCropTypeId) {
        param.cropId = this.tbCropTypeId;
      }
      param.entityId = this.entityId;
      this.baocaoService.reportExportActivity(param).subscribe(
        (resp: HttpResponse<Blob>) => {
          this.onSaveSuccess(resp);
        },
        () => this.onSaveError(),
      );
    }
  }
  startDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.minDate = new Date(event.value);
    this.minDate.setDate(this.minDate.getDate());
    this.startDate = this.minDate;
    this.check = false;
  }

  endDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.endDate = new Date(event.value);
  }

  private onSaveError() {
    this.isSaving = false;
  }

  private onSaveSuccess(result) {
    const contentDisposition = result.headers.get('content-disposition');
    const filename = contentDisposition
      .split(';')[1]
      .split('filename')[1]
      .split('=')[1]
      .trim();
    if (filename) {
      saveAs(result.body, filename);
    } else {
      alert(
        this.translate.instant(
          'entities.bao-cao.bao-cao.Không tìm thấy filename_alert',
        ),
      );
    }
    this.isSaving = false;
  }
  getEntityData() {
    this.entityDaTa = this.service
      .queryByTopLevel()
      .pipe(map((res) => res.body || []));
  }

  getCropData(entityId) {
    if (entityId) {
      this.canhTacService
        .dropdownListCropByEntity(entityId)
        .subscribe((res: any) => {
          this.tbCropTypeId$ = res.body ? res.body : [];
        });
    } else {
      this.tbCropTypeId$ = [];
      this.tbCropTypeId = null;
    }
  }
}
